import React, { useCallback, useMemo } from 'react';
import { EXPERIMENTS } from '../../../constants';
import { useConfig } from '../../../contexts/config-context';
import { useExperiments } from '../../../contexts/experiments-context';
import { useFieldActions } from '../../../contexts/field-actions-context';
import { useFieldValidation } from '../../../contexts/field-validation-context';
import { useForm } from '../../../contexts/form-context';
import { createFormView } from '../../../services/form-view';
import { Form } from '../../../ui/form/components/form';
import { useFormFields } from '../../../ui/form/contexts/form-fields-context';
import { createFullNameFormSchema } from './create-full-name-form-schema';
import styles from './full-name.module.scss';
import { useIsJapanOrder } from './use-is-japan-order';
const NO_VALUES = {};
const NO_ERRORS = [];
const FullName = _ref => {
  let {
    id,
    target,
    value,
    onChange,
    onFieldBlur,
    onFieldFocus,
    errors,
    label,
    FieldLayout,
    validation
  } = _ref;
  const isJapanOrder = useIsJapanOrder();
  const {
    isMobile,
    breakpoint
  } = useConfig();
  const {
    isExperimentEnabled
  } = useExperiments();
  const useFieldsV2 = isExperimentEnabled(EXPERIMENTS.USE_FIELDS_V2);
  const {
    validateFields
  } = useFieldValidation();
  const formSchema = useForm();
  const fields = useFormFields();
  const fieldActions = useFieldActions();
  const form = useMemo(() => createFormView({
    form: createFullNameFormSchema(isJapanOrder, validation),
    path: target,
    parentId: id,
    isMobile,
    breakpoint,
    useFieldsV2
  }), [isJapanOrder, validation, target, id, isMobile, breakpoint, useFieldsV2]);
  const handleFieldChange = useCallback((subTarget, subValue) => {
    onChange == null || onChange({
      ...value,
      [subTarget]: subValue
    });
  }, [onChange, value]);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id
  }, /*#__PURE__*/React.createElement("fieldset", {
    className: styles.reset
  }, /*#__PURE__*/React.createElement("legend", {
    className: styles.visuallyHidden
  }, label), /*#__PURE__*/React.createElement(Form, {
    formSchema: formSchema,
    form: form,
    values: value ?? NO_VALUES,
    onFieldChange: handleFieldChange,
    onBlur: onFieldBlur,
    onFocus: onFieldFocus,
    errors: errors ?? NO_ERRORS,
    validateFields: validateFields,
    fields: fields,
    fieldActions: fieldActions
  })));
};
export default FullName;
//# sourceMappingURL=full-name.js.map